import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AuthGuardService } from '@app/helpers';
import { SharedModule } from '@app/shared';
import { CompanyService } from '@services/company.service';
import { ThemeModule } from '@theme/theme.module';
import { DxDataGridModule } from 'devextreme-angular';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { MyCompanyModule } from './my-company/my-company.module';
import { OrganizationRoutingModule } from './organization-routing.module';
import { OrganizationsComponent } from './organizations/organizations.component';

const PAGES_COMPONENTS = [];

@NgModule({
  imports: [
    CommonModule,
    OrganizationRoutingModule,
    ThemeModule,
    MyCompanyModule,
    Ng2TelInputModule,
    SharedModule,
    DxDataGridModule
  ],
  declarations: [...PAGES_COMPONENTS, OrganizationsComponent],
  providers: [AuthGuardService, CompanyService],
})
export class OrganizationModule {}
